import axios from 'axios';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import VideoPlayer from './VideoPlayer';
import Spinner from './Utils/Spinner';
import AppContext from './Context/AppContext';
import Header from './Main/Header';
import Card from './mainComponents/Card';

const MovieWatchScreen = () => {
    const ctx = useContext(AppContext);

    const params = useParams();
    const watchId = params.watchId;
    const [data, setData] = useState();
    const [error, setError] = useState();
    const sourceRef = useRef();
    const [source, setSource] = useState('0');

    const url = ctx.apiUrl + '/api/movie/' + watchId;
    useEffect(() => {
        setData();

        axios
            .get(url)
            .then((response) => {
                setData(response.data);
            })
            .catch((error) => {
                const errorMessage = error.response ? error.response.data : error.message;
                setError(errorMessage);
            });
    }, [watchId]);

    const changeSource = () => {
        setSource(sourceRef.current.value);
    };

    return (
        <>
            <div className='h-screen relative'>
                <Header />

                {data && (
                    <>
                        <div className='absolute -z-20 right-0 top-0 h-full w-full'>
                            <img
                                className='h-full w-full object-cover'
                                src={`https://image.tmdb.org/t/p/w500${data.data.backdrop_path}`}
                                alt=''
                            />
                        </div>

                        <div className='absolute top-0 -z-10 right-0 h-full w-full bg-black opacity-80'></div>
                        <div className='h-5/6 w-screen overflow-y-scroll'>
                            <div className='h-5'></div>
                            <div className='text-white text-xl text-center p-2'>{data.data.title}</div>
                            {data.data.tagline && (
                                <div className='text-white text-xs text-center p-2'>({data.data.tagline})</div>
                            )}
                            <br />

                            <div className='flex flex-col items-center'>
                                <div className='flex flex-col space-y-1 items-center w-full md:w-3/5'>
                                    {source === '0' && <VideoPlayer video={data.sources[0]} track={data.track} />}
                                    {source === '1' && <VideoPlayer video={data.sources[1]} track={data.track} />}
                                    {source === '2' && <VideoPlayer video={data.sources[2]} track={data.track} />}
                                    {source === '3' && <VideoPlayer video={data.sources[3]} track={data.track} />}

                                    <div className='form-contol'>
                                        <select
                                            className='select select-sm w-28'
                                            ref={sourceRef}
                                            onChange={changeSource}
                                        >
                                            <option value='0'>Auto</option>

                                            <option value='1'>360p</option>
                                            <option value='2'>720p</option>
                                            <option value='3'>1080p</option>
                                        </select>
                                    </div>

                                    <a
                                        className='btn btn-sm btn-solid-primary'
                                        href={data.sources[0]}
                                        target='_blank'
                                        rel='noreferrer'
                                    >
                                        Download
                                    </a>
                                </div>
                                <br />
                                <div className='flex justify-center flex-col sm:flex-row items-center w-11/12 sm:w-4/5 md:w-2/4'>
                                    <div className='flex sm:hidden'>
                                        <img
                                            className='sm:h-48 sm:w-36 w-20 h-32 shadow-md rounded-lg m-2 object-cover'
                                            src={`https://image.tmdb.org/t/p/w500${data.data.poster_path}`}
                                            alt=''
                                        />
                                        <table className='text-white font-medium text-xs'>
                                            <tbody>
                                                <tr>
                                                    <td>Title</td>
                                                    <td>
                                                        <p className='text-right'>{data.data.title}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Released</td>
                                                    <td>
                                                        <p className='text-right'>{data.data.release_date}</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Duration</td>
                                                    <td>
                                                        <p className='text-right'>{data.data.runtime}min</p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Genre</td>
                                                    <td>
                                                        <p className='text-right w-full break-keep'>
                                                            {data.data.genres.map(function (genre, index) {
                                                                return <span key={index}>{genre.name}, </span>;
                                                            })}
                                                        </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <img
                                        className=' hidden sm:block sm:h-48 sm:w-36 w-20 h-32 shadow-md rounded-lg m-2 object-cover'
                                        src={`https://image.tmdb.org/t/p/w500${data.data.poster_path}`}
                                        alt=''
                                    />
                                    <div className='text-white text-xs sm:text-sm'>{data.data.overview}</div>
                                </div>
                            </div>

                            {data.data.collection && (
                                <>
                                    <div className='divider divider-horizontal'></div>
                                    <div className='text-md font-semibold p-2'>
                                        {data.data.belongs_to_collection.name}
                                    </div>
                                    <div className='flex overflow-x-scroll space-x-2 p-2 '>
                                        {data.data.collection.parts.map((item, index) => {
                                            return (
                                                <div key={index} className='flex m-2'>
                                                    <Card item={item} recommended={true} />
                                                </div>
                                            );
                                        })}
                                    </div>
                                </>
                            )}

                            <div className='divider divider-horizontal'></div>
                            <div className='text-md font-semibold p-2'>Recommended</div>
                            <div className='flex overflow-x-scroll space-x-2 p-2'>
                                {data.data.recommendations.results.map((item, index) => {
                                    return (
                                        <div key={index} className='flex m-2'>
                                            <Card item={item} recommended={true} />
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </>
                )}
                {!data && !error && (
                    <div className='h-5/6 w-screen overflow-hidden flex justify-center items-center'>
                        <div className='flex items-center space-x-2'>
                            <Spinner className='spinner-sm' /> <span>Loading</span>
                        </div>
                    </div>
                )}
                {error && (
                    <div className='h-5/6 bg-backgroundSecondary w-screen overflow-hidden flex justify-center items-center'>
                        <div className='flex items-center space-x-2'>
                            <span className='text-error'>{error}</span>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default MovieWatchScreen;
